import React from 'react';
import './index.css';
import { FaFacebookSquare, FaInstagramSquare, FaLinkedin, FaGithubSquare, FaPhoneAlt, FaEnvelope  } from "react-icons/fa";

const TopHeader = () => {
    return (
        <div id="topbar" className="d-flex align-items-center fixed-top">
            <div className="container d-flex justify-content-between">
                <div className="contact-info d-flex align-items-center">
                    <FaEnvelope className='contact-icon'/> <a href="mailto:support@specialisthub.co.zw">support@specialisthub.co.zw</a>
                    <FaPhoneAlt className='contact-icon'/> <a href="tel:+263779484938">+263 779 484 938</a>
                </div>
                <div className="d-none d-lg-flex social-links align-items-center">
                    <a href="https://wa.me/263779484938" target='_blank' rel="noreferrer" className="linkedin"><FaPhoneAlt /></a>
                </div>
            </div>
        </div>
    );
};
export default TopHeader;